export default "/img/SC.9f118e91168cc0e2a4031131152aec00.png";